<script setup>
const props = defineProps({
    msgConfig: {
        type: Object,
        default: () => {},
        validator(rawValue) {
            const validations = {
                message: rawValue => rawValue?.message === undefined || typeof rawValue?.message === 'string',
                error: rawValue => rawValue?.error === undefined || typeof rawValue?.error === 'boolean',
                success: rawValue => rawValue?.success === undefined || typeof rawValue?.success === 'boolean',
            }

            return Object.values(validations).every(validation => validation(rawValue))
        }
    }
})

const formInputClass = computed(() => {
    return {
        'form-error-message': props?.msgConfig?.error,
        'form-success-message': props?.msgConfig?.success
    }
})
</script>

<template>
    <span v-if="(msgConfig.error || msgConfig.success) && msgConfig.message" :class="formInputClass">
        {{ msgConfig.message }}
    </span>
</template>

<style lang="scss">
.form-error-message {
    @include form-input-message($type: 'error');

    .form-input-radio-group & {
        width: 100%;
        margin-inline-start: px2rem(20);

        @include bp(medium1) {
            margin-inline-start: px2rem(40);
        }
    }
}

.form-success-message {
    @include form-input-message($type: 'success');

    .form-input-radio-group & {
        width: 100%;
        margin-inline-start: px2rem(20);

        @include bp(medium1) {
            margin-inline-start: px2rem(40)
        }
    }
}
</style>
